import { Overlay } from "../overlay";
import { useModalContext } from "./context";

export function ModalOverlay() {
	/** Context */
	const { onClose } = useModalContext();

	/** Render */
	return <Overlay onClick={onClose} />;
}
